export default "__VITE_ASSET__DTfmJj$p__"